import styled, { css } from "styled-components";
import { TablePageContent } from "components/TablePageLayout";
import { pxToRem, withAlpha } from "../../styles/utils";

export const LeadsPageContainer = styled.div`
  display: flex;
  height: calc(100% - ${pxToRem(24)});
  margin: ${({ theme }) => pxToRem(theme.spacing.sm)};
`;

export const ContentWrapper = styled(TablePageContent)<{ $roleFilterActive?: boolean }>`
  background: ${({ theme }) => theme.colors.white};
  border-radius: ${({ theme }) => pxToRem(theme.radii.lg)};
  box-shadow: ${({ theme }) => theme.shadows.md}, ${({ theme }) => theme.shadows.ring};
  padding: ${({ theme }) => pxToRem(theme.spacing.xxl)} ${({ theme }) => pxToRem(theme.spacing.xl)};

  table > thead > tr > th:nth-child(6) svg[class*="FilterIcon"] {
    border-radius: ${({ theme }) => pxToRem(theme.radii.sm)};
    color: ${({ theme }) => theme.colors.inkMuted};
    transition:
      background-color 0.15s ease,
      color 0.15s ease;

    &:hover {
      background: ${({ theme }) => withAlpha(theme.colors.ink, 0.06)};
      color: ${({ theme }) => theme.colors.ink};
    }

    ${({ $roleFilterActive, theme }) =>
      $roleFilterActive &&
      css`
        background: ${theme.colors.brandSubtle};
        color: ${theme.colors.brand};
      `}
  }
`;

export const Title = styled.h1`
  margin: 0 0 ${({ theme }) => pxToRem(theme.spacing.lg)};
  color: ${({ theme }) => theme.colors.ink};
  font-size: ${({ theme }) => pxToRem(theme.fontSize.xxl)};
  font-weight: 700;
`;

export const AppliedFiltersBar = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: ${pxToRem(10)};
  margin-top: ${pxToRem(-4)};
  margin-bottom: ${pxToRem(17.5)};
  min-height: ${pxToRem(37.5)};
`;

export const AppliedFilterLabel = styled.span`
  color: ${({ theme }) => theme.colors.inkMuted};
  font-size: ${({ theme }) => pxToRem(theme.fontSize.md)};
  font-weight: 400;
`;

export const AppliedFilterPill = styled.span`
  display: inline-flex;
  align-items: center;
  gap: ${pxToRem(7.5)};
  height: ${pxToRem(35)};
  padding: 0 ${pxToRem(7.5)} 0 ${pxToRem(13.75)};
  border-radius: ${({ theme }) => pxToRem(theme.radii.md)};
  background: ${({ theme }) => theme.colors.brandSubtle};
  color: ${({ theme }) => theme.colors.brand};
  font-size: ${({ theme }) => pxToRem(theme.fontSize.md)};
  font-weight: 400;
`;

export const RemoveAppliedFilterButton = styled.button`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${pxToRem(22.5)};
  height: ${pxToRem(22.5)};
  padding: 0;
  border: 0;
  border-radius: ${({ theme }) => pxToRem(theme.radii.sm)};
  background: transparent;
  color: inherit;
  cursor: pointer;

  &::before,
  &::after {
    content: "";
    position: absolute;
    width: ${pxToRem(11)};
    height: ${pxToRem(1.8)};
    border-radius: ${pxToRem(2)};
    background: currentColor;
  }

  &::before {
    transform: rotate(45deg);
  }

  &::after {
    transform: rotate(-45deg);
  }

  &:hover {
    background: ${({ theme }) => withAlpha(theme.colors.brand, 0.16)};
  }

  &:focus-visible {
    outline: ${pxToRem(2)} solid ${({ theme }) => theme.colors.brand};
    outline-offset: ${pxToRem(2)};
  }
`;

export const LeadNoteButton = styled.button`
  padding: 0;
  border: 0;
  background: transparent;
  color: ${({ theme }) => theme.colors.brand};
  font: inherit;
  font-weight: 400;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }

  &:focus-visible {
    outline: ${pxToRem(2)} solid ${({ theme }) => theme.colors.brand};
    outline-offset: ${pxToRem(2)};
    border-radius: ${({ theme }) => pxToRem(theme.radii.sm)};
  }
`;

export const StatusAndDeleteIconContainer = styled.div.attrs({ className: "table-actions" })`
  display: flex;
  justify-content: center;
`;
